import React from 'react';
import Typography from '@material-ui/core/Typography';
import { formatMoney } from '../utils';
/**
 * Компонент отображающий стоимость и ее валюту.
 */
export default function Cost(props) {
    return React.createElement(Typography, { variant: props.amountVariant || "inherit", component: props.component || "div" },
        formatMoney(props.amount, { localeAware: true, currency: props.currency }),
        " ",
        React.createElement(Typography, { variant: props.currencyVariant || "inherit", component: "span" }, props.currency)) || null;
}
